// extracted by mini-css-extract-plugin
export var headerWrapper = "theLatestNews-module--headerWrapper--SlXIW";
export var latestLink = "theLatestNews-module--latestLink--7x0f-";
export var newsCornice = "theLatestNews-module--newsCornice--EeFuX";
export var theLatestNews = "theLatestNews-module--theLatestNews--2QT6n";
export var wrapper = "theLatestNews-module--wrapper--3J7b1";